import ajax from "@/lib/ajax";

// Charge/GetChargeCollects
// 查询缴费汇总信息
export async function GetChargeCollects(payload: any){
	let res = await ajax.get('/api/services/app/Charge/GetChargeCollects', {params:payload})
	return res.data.result
}
// Charge/GetChargeCollectDetail
// 查询缴费明细
export async function GetChargeCollectDetail(payload: any){
	let res = await ajax.get('/api/services/app/Charge/GetChargeCollectDetail', {params:payload})
	return res.data.result
}
// Charge/GetAccount
// 账户管理
export async function GetAccount(payload: any){
	let res = await ajax.get('/api/services/app/Charge/GetAccount', {params:payload})
	return res.data.result
}
// Charge/GetDlyPays
// 充值记录
export async function GetDlyPays(payload: any){
	let res = await ajax.get('/api/services/app/Charge/GetDlyPays', {params:payload})
	return res.data.result
}
// Charge/SaveDlyPay
// 充值
export async function SaveDlyPay(payload: any){
	let res = await ajax.post('/api/services/app/Charge/SaveDlyPay', payload)
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/charge/index.ts